import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import KendoTreeListDataSourceMixin from './KendoTreeListDataSourceMixin'

export default {
    name: 'kendo-treelistdatasource',
    mixins: [ KendoTreeListDataSourceMixin ],
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoTreeListDataSource/index.js